<template>
  <div class="container">
    <br />
    <div class="card">
      <div class="row">
        <div class="col">
          <button
            @click="$router.back()"
            type="button"
            class="col col-sm-2 btn btn-secondary p-2"
          >
            Volver
          </button>
        </div>
      </div>
      <br />
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
        <div class="shadow-title border-radius-lg pt-2 pb-2">
          <h6 class="size-text color-text text-capitalize text-center">
            Seleccione Perfil
          </h6>
        </div>
      </div>
      <div class="card-body mt-2">
        <div class="row text-center justify-content-center hidden">
          <div class="container contenido">
            <div class="text-center content-item mt-2 mb-4 pointer">
              <div @click="showModal" class="image">
                <img
                  class="image-item"
                  src="../../../src/assets/5322033.png"
                  alt=""
                />
              </div>
              <h4>Admin</h4>
            </div>
            <div class="text-center content-item mt-2 ms-6 pointer">
              <div @click="showModal1" class="image">
                <img
                  class="image-item"
                  src="data:image/jpeg;base64,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"
                  alt=""
                />
              </div>
              <h4>Gestor</h4>
            </div>
          </div>
          <div class="container contenido mt-4 mb-5">
            <div class="text-center content-item mt-2 pointer">
              <div @click="showModal2" class="image">
                <img
                  class="image-item"
                  src="../../../src/assets/instructor.png"
                  alt=""
                />
              </div>
              <h4>Instructor</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div><Modal v-show="isModalVisible" @close="closeModal" /></div>
        <div><Modal1 v-show="isModalVisible1" @close="closeModal1" /></div>
        <div><Modal2 v-show="isModalVisible2" @close="closeModal2" /></div>
      </div>
    </div>
    <br />
  </div>
</template>
eslint-disable

<script>
import Modal from "@/components/reports/Admin.vue";
import Modal1 from "@/components/reports/Gestor.vue";
import Modal2 from "@/components/reports/Instructor.vue";
export default{
components:{Modal, Modal1, Modal2,}, 
data(){return{isModalVisible: false, isModalVisible1: false, isModalVisible2: false,};},
 methods:{
showModal2(){this.isModalVisible2=true;}, closeModal2(){this.isModalVisible2=false;}, 
 showModal1(){this.isModalVisible1=true;}, closeModal1(){this.isModalVisible1=false;}, 
 showModal(){this.isModalVisible=true;}, closeModal(){this.isModalVisible=false;},},};
</script>
<style>
.color-text {
  color: #00324d;
}
.contenido {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: auto;
  transition: all 120ms;
}
.shadow-title {
  box-shadow: 0px 0px 10px 0px #fd671a !important;
}
.size-text {
  font-size: 35px;
}
.content-item {
  width: 280px;
  height: 240px;
  box-shadow: 0px 0px 8px 4px #007bb8 !important;
  border-radius: 15px;
  overflow: hidden;
}
.image {
  height: 210px;
  width: auto;
  overflow: hidden;
  background-repeat: no-repeat;
}
.image-item {
  background-repeat: no-repeat;
  max-width: 100%;
  height: 100%;
}
.btn-secondary {
  background: #fd671a !important;
}
.pointer:hover {
  cursor: pointer;
}
@media (max-width: 769px) {
  .content-item {
    /* background-color: #007bb8; */
    margin-left: 0px !important ;
    padding-left: 0px !important;
    left: 0% !important;
  }
}
</style>
